import {createContext, useContext, useState, useMemo} from 'react';

export const WholesalerContext = createContext<IWholesalerContext>({
  wholesaler: undefined,
  updateTypeOfAd: () => null,
  updateTypePost: () => null,
  updateWholesalerForm: () => null,
  uploadQualifyForm: () => null,
  updateSubProduct: () => null,
  resetForm: () => null,
  setOldImages: () => null,
  setDeleteOldImages: () => null,
});

type TShopProviderProps = {
  children: React.ReactNode;
};

export const WholesalerProvider = ({children}: TShopProviderProps) => {
  const [wholesaler, setWholesaler] = useState<
    IWholesalerAddInfo | undefined
  >();

  const updateSubProduct = (subProduct: string) => {
    if (subProduct)
      setWholesaler(prev => ({
        ...prev,
        subProduct,
      }));
  };

  const updateTypeOfAd = (appType: string) => {
    if (appType)
      setWholesaler(prev => ({
        ...prev,
        appType,
      }));
  };

  const updateTypePost = (type: string) => {
    if (type)
      setWholesaler(prev => ({
        ...prev,
        type,
      }));
  };
  const updateWholesalerForm = (data: IWholesalerInfoFormData) => {
    if (data)
      setWholesaler(prev => ({
        ...prev,
        title: data.title,
        description: data.description,
        state: data.state,
        city: data.city,
        hide_phone_number: data.hide_phone_number,
      }));
  };
  const uploadQualifyForm = (qualifyData: IQualityFormData) => {
    if (qualifyData)
      setWholesaler(prev => ({
        ...prev,
        images: qualifyData.images,
        existing: qualifyData.existing,
        existing_unit: qualifyData.existing_unit,
      }));
  };
  const setOldImages = (images: Array<IImage>) => {
    setWholesaler(prev => ({...prev, oldImages: images}));
  };
  const setDeleteOldImages = (image: string) => {
    setWholesaler(prev => {
      if (prev?.deleted_images) {
        if (prev?.deleted_images.indexOf(image) > -1) {
          return {
            ...prev,
            
          };
        } else
          return {
            ...prev,
            deleted_images: [...prev.deleted_images, image],
          };
      } else {
        return {
          ...prev,
          deleted_images: [image],
        };
      }
    });
  };

  const resetForm = () => {
    setWholesaler(undefined);
  };

  const value = useMemo(
    () => ({
      wholesaler,
      updateSubProduct,
      updateTypeOfAd,
      updateTypePost,
      updateWholesalerForm,
      uploadQualifyForm,
      resetForm,
      setOldImages,
      setDeleteOldImages,
    }),
    [wholesaler],
  );
  return (
    <WholesalerContext.Provider value={value}>
      {children}
    </WholesalerContext.Provider>
  );
};

export const useWholesaler = () => {
  return useContext(WholesalerContext);
};
